import { useState, useEffect, useRef } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'
import emailjs from '@emailjs/browser'
import './index.scss'

const PaymentSuccess = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const form = useRef()

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    const sendEmail = (e) => {
        e.preventDefault()
        setLoading(true)

        // TODO: Replace with your actual EmailJS credentials
        // You can get these from https://dashboard.emailjs.com/
        const SERVICE_ID = 'YOUR_SERVICE_ID'
        const TEMPLATE_ID = 'YOUR_TEMPLATE_ID'
        const PUBLIC_KEY = 'YOUR_PUBLIC_KEY'

        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
            .then(() => {
                setSubmitted(true)
                setLoading(false)
            }, (error) => {
                console.log(error.text)
                alert('Failed to send the form. Please try again or contact us directly.')
                setLoading(false)
            })
    }

    return (
        <>
            <div className="container payment-success-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['S', 'u', 'c', 'c', 'e', 's', 's', '!']}
                            idx={15}
                        />
                    </h1>

                    {!submitted ? (
                        <>
                            <p>
                                Thank you for your payment! Please fill out this short intake form so we can prepare for our kickoff call.
                            </p>
                            <div className="intake-form">
                                <form ref={form} onSubmit={sendEmail}>
                                    <ul>
                                        <li className="half">
                                            <input placeholder="Name" type="text" name="user_name" required />
                                        </li>
                                        <li className="half">
                                            <input placeholder="Email" type="email" name="user_email" required />
                                        </li>
                                        <li>
                                            <input placeholder="What tickers or sectors are you interested in? (e.g., AAPL, Tech, Biotech)" type="text" name="tickers" required />
                                        </li>
                                        <li>
                                            <textarea placeholder="Any constraints, specific requirements, or notes for us?" name="message" required></textarea>
                                        </li>
                                        <li>
                                            <button type="submit" className="flat-button" disabled={loading}>
                                                {loading ? 'SENDING...' : 'SUBMIT DETAILS'}
                                            </button>
                                        </li>
                                    </ul>
                                </form>
                            </div>
                        </>
                    ) : (
                        <div className="success-message">
                            <h2>Details Received!</h2>
                            <p>
                                We have sent a confirmation email to the address you provided.
                                It contains your expected delivery date and a brief explanation of our next steps.
                                <br /><br />
                                We will be in touch shortly to schedule your kickoff call.
                            </p>
                            <a href="/" className="flat-button">Back to Home</a>
                        </div>
                    )}
                </div>
            </div>
            <Loader type="ball-scale-multiple" />
        </>
    )
}

export default PaymentSuccess
